import { c as _c } from "react/compiler-runtime";
import { CdnImage } from '@cc-shopping/ui/primitives/CdnImage';
import { Box, Typography } from '@mui/material';
import type * as v from 'valibot';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { CreditCardsSlideshowShell } from './CreditCardsSlideshow.client';
import type { CreditCardsSlideshowSCSchema } from './schema';
export type CreditCardsSlideshowProps = StructuredContentDocumentWithRenderer<v.InferInput<typeof CreditCardsSlideshowSCSchema>>;
export const CreditCardsSlideshow = t0 => {
  const $ = _c(7);
  const {
    props
  } = t0;
  let t1;
  if ($[0] !== props.children) {
    t1 = props.children.map(_temp);
    $[0] = props.children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slideContents = t1;
  let t2;
  if ($[2] !== props.children) {
    t2 = props.children.map(_temp2);
    $[2] = props.children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const slideImages = t2;
  let t3;
  if ($[4] !== slideContents || $[5] !== slideImages) {
    t3 = <CreditCardsSlideshowShell slideContents={slideContents} slideImages={slideImages} />;
    $[4] = slideContents;
    $[5] = slideImages;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(t0, index) {
  const {
    props: slideProps
  } = t0;
  return <Box key={`slide-content-${index}`} display="flex"><Typography marginRight={3} variant="textLargeBold" fontSize={24}>{`${index + 1}.`}</Typography><Box display="flex" flexDirection="column" gap={3}><Typography variant="textLargeBold" fontSize={24}>{slideProps.header}</Typography>{renderStructuredContent(slideProps.children)}</Box></Box>;
}
function _temp2(t0, index_0) {
  const {
    props: slideProps_0
  } = t0;
  return <CdnImage key={`slide-image-${index_0}`} src={slideProps_0.imageUrl} alt={slideProps_0.imageAltText || `${slideProps_0.header} image`} height={180} className="slideshow-image" width={300} style={{
    objectFit: "contain",
    objectPosition: "center"
  }} />;
}